<template>
  <v-container fluid>
    <material-card
      v-if="cityList.length"
      icon="mdi-city"
      inline
      title="City List"
    >
      <v-card-text
        class="pt-0 pr-1"
        :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }"
      >
        <v-text-field
          :class="{
            'mr-0': $vuetify.breakpoint.xs,
            'mr-5': $vuetify.breakpoint.smAndUp
          }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width: 350px"
        />
        <router-link
          :to="{ name: 'SaveCity' }"
          :class="{ 'd-flex justify-start': $vuetify.breakpoint.xs }"
        >
          <v-btn
            elevation="1"
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent"
          >
            <v-icon left>mdi-plus</v-icon>
            Add City
          </v-btn>
        </router-link>
      </v-card-text>

      <v-divider class="my-0" />
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="cityList"
        :search.sync="search"
      >
        <template v-slot:item.isActive="{ item }">
          <div :style="item.isActive ? 'color:#4CAF50' : 'color:#F44336'">
            {{ item.isActive ? 'Active' : 'In Active' }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <router-link :to="{ name: 'editCity', params: { cityId: item.id } }">
            <v-btn
              class="px-2 ml-1 white--text ma-1"
              color="success"
              small
              icon
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </router-link>
          <v-btn
            v-if="item.isActive"
            @click="deactivateCity(item.id)"
            class="px-2 ml-1 white--text ma-1"
            color="error"
            small
            icon
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            v-else
            @click="restoreCity(item.id)"
            class="px-2 ml-1 white--text ma-1"
            color="error"
            small
            icon
          >
            <v-icon small>mdi-restore</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center"
            >No Data Available</v-card-subtitle
          >
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
export default {
  components: { MaterialCard },
  name: 'CityStateList',

  data () {
    return {
      enablePagination: false,
      cityList: [],
      endPoints: [],
      loadingComponent: null,
      myloadingvariable: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'State', value: 'state', sortable: true },
        { text: 'City', value: 'cityName', sortable: true },
        { text: 'Is Active', value: 'isActive', sortable: false },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    }
  },

  created () {
    this.getStateCityList()
  },
  methods: {
    getStateCityList: async function () {
      this.cityList = []
      this.loadingComponent = this.$buefy.loading.open()
      await http
        .get(`${CONSTANTS.API_URL}/api/cityandstate/city-state-list`)
        .then((res) => {
          if (res.status === 200) {
            res.data.forEach((item) => {
              if (
                typeof item.cities !== 'undefined' &&
                item.cities.length > 0
              ) {
                item.cities.forEach((obj) => {
                  this.cityList.push({
                    id: obj.id,
                    state: item.state,
                    cityName: obj.cityName,
                    isActive: obj.isActive
                  })
                })
              }
            })
            this.loadingComponent.close()
          } else {
            this.loadingComponent.close()
            return this.$dialog.message.error(res.data, {
              position: 'top-right',
              color: 'error',
              timeout: 4000
            })
          }
        })
        .catch((e) => {
          this.loadingComponent.close()
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.message.error(errorMessage, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
    },
    deactivateCity: function (cityId) {
      this.$dialog.confirm({
        title: 'Deactivate City?',
        text: 'Are you sure you want to <b>deactivate</b> this city?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                return http
                  .put(
                    `${CONSTANTS.API_URL}/api/cityandstate/inactive-city/${cityId}`
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      this.getStateCityList()
                      this.loadingComponent.close()
                      this.$dialog.message.info(
                        'City deactivated Successfully',
                        {
                          position: 'top-right',
                          color: 'success',
                          timeout: 4000
                        }
                      )
                    } else {
                      this.loadingComponent.close()
                      this.$dialog.message.error('Failed to deactivate city.', {
                        position: 'top-right',
                        color: 'error',
                        timeout: 4000
                      })
                    }
                  })
              } catch (e) {
                this.loadingComponent.close()
                this.$dialog.message.info(e.response.data.message, {
                  position: 'top-right',
                  color: 'error',
                  timeout: 4000
                })
              }
            }
          }
        }
      })
    },
    restoreCity: function (cityId) {
      this.$dialog.confirm({
        title: 'Activate City?',
        text: 'Are you sure you want to <b>activate</b> this city?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                return http
                  .put(
                    `${CONSTANTS.API_URL}/api/cityandstate/inactive-city/${cityId}`
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      this.getStateCityList()
                      this.loadingComponent.close()
                      this.$dialog.message.info(
                        'City activated successfully. ',
                        {
                          position: 'top-right',
                          color: 'success',
                          timeout: 4000
                        }
                      )
                    } else {
                      this.loadingComponent.close()
                      this.$dialog.message.error('Failed to activate city.', {
                        position: 'top-right',
                        color: 'error',
                        timeout: 4000
                      })
                    }
                  })
              } catch (e) {
                this.loadingComponent.close()
                this.$dialog.message.info(e.response.data.message, {
                  position: 'top-right',
                  color: 'error',
                  timeout: 4000
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
